module.exports = __webpack_public_path__ + "img/img.5d6fcc17.png";